module.exports = __webpack_public_path__ + "static/media/paper.70fba742.jpg";